import React from 'react';
import OnboardingContent from '../components/OnboardingContent/OnboardingContent';
import CtaSection from '../components/CtaSection/CtaSection';

const OnboardingPage = () => {
  return (
    <>
      <OnboardingContent />
      <CtaSection />
    </>
  );
};

export default OnboardingPage;
